module.exports = __webpack_public_path__ + "img/window_svg.58151928.svg";